// proto/v2/workflow/workflow.proto
//
// Workflow main CRUD over WS — Wave 3c.1 HTTP→WS migration.
// Covers 13 user-facing routes from internal/workflow/api/{handler,draft_handler}.go.
// Triggers, templates, and validate are Wave 3c.2 (separate commit).
//
// Workflow specs intentionally stay OPAQUE on the wire (bytes workflow_spec):
// the spec format (YAML/JSON) is still iterating — a typed proto schema
// would block workflow engine evolution. Server-side parsing/validation is
// unchanged.
//
// External-inbound routes (webhook receivers, email ingress) stay HTTP
// indefinitely — external systems can't speak WS.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file workflow/workflow.proto (package lvdr.v2.workflow, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { LimitCut, LimitDetail, ValidationIssue } from "../errors/errors_pb";
import { file_errors_errors } from "../errors/errors_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file workflow/workflow.proto.
 */
export const file_workflow_workflow: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_errors_errors]);

/**
 * WorkflowSummary is the list-view row. No spec body — that's fetched
 * separately by GetWorkflow.
 *
 * @generated from message lvdr.v2.workflow.WorkflowSummary
 */
export type WorkflowSummary = Message<"lvdr.v2.workflow.WorkflowSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "active" today; room for "draft" / "archived"
   *
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workflow.WorkflowSummary.
 * Use `create(WorkflowSummarySchema)` to create a new message.
 */
export const WorkflowSummarySchema: GenMessage<WorkflowSummary> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 0);

/**
 * WorkflowInstanceSummary describes one execution. finished_at/duration_ms/
 * error are only populated for terminal states (completed, failed) — wire
 * format uses zero-values (empty string / 0) as "not set" rather than
 * proto3 optional, matching the HTTP JSON's omitempty behavior.
 *
 * @generated from message lvdr.v2.workflow.WorkflowInstanceSummary
 */
export type WorkflowInstanceSummary = Message<"lvdr.v2.workflow.WorkflowInstanceSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * pending | running | completed | failed | cancelled
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * INTERNAL USD — never surfaced to users; see *_credits
   *
   * @generated from field: double budget_used = 4;
   */
  budgetUsed: number;

  /**
   * INTERNAL USD — never surfaced to users; see *_credits
   *
   * @generated from field: double budget_cap = 5;
   */
  budgetCap: number;

  /**
   * RFC3339
   *
   * @generated from field: string started_at = 6;
   */
  startedAt: string;

  /**
   * empty if not terminal
   *
   * @generated from field: string finished_at = 7;
   */
  finishedAt: string;

  /**
   * 0 if not terminal
   *
   * @generated from field: int64 duration_ms = 8;
   */
  durationMs: bigint;

  /**
   * empty if not failed
   *
   * @generated from field: string error = 9;
   */
  error: string;

  /**
   * empty if manual
   *
   * @generated from field: string trigger_type = 10;
   */
  triggerType: string;

  /**
   * User-facing budget in CREDITS, converted server-side from the USD fields
   * above via credits.CreditPricing (credits = USD × CreditsPerDollar × (1+Margin)).
   * The FE displays ONLY these — the product never shows raw USD.
   *
   * @generated from field: int64 budget_used_credits = 11;
   */
  budgetUsedCredits: bigint;

  /**
   * @generated from field: int64 budget_cap_credits = 12;
   */
  budgetCapCredits: bigint;

  /**
   * Steps this run is suspended on awaiting a human decision. Only `approval`
   * suspensions appear here — delay/event suspensions resume on their own and
   * need no UI. Without this the frontend knows a run is suspended but not
   * WHICH step to approve, and ApproveWorkflowStepRequest requires a step_id.
   *
   * @generated from field: repeated lvdr.v2.workflow.PendingApproval pending_approvals = 13;
   */
  pendingApprovals: PendingApproval[];

  /**
   * Every step of this run: the ones that ran first, in execution order, then
   * the ones that have not, in SPEC order (not alphabetical — `step10` before
   * `step2` scrambled the whole upcoming half of a running run's timeline).
   * Populated ONLY by GetWorkflowInstance — ListWorkflowInstances leaves it
   * empty by design, see StepSummary.
   *
   * @generated from field: repeated lvdr.v2.workflow.StepSummary steps = 14;
   */
  steps: StepSummary[];

  /**
   * AON-06: steps suspended because a connection in the always-on space needs
   * to be reconnected (`reconnect` suspensions). The user reconnects, then
   * sends ResumeReconnectWorkflowStepRequest for the step.
   *
   * @generated from field: repeated lvdr.v2.workflow.PendingReconnect pending_reconnects = 15;
   */
  pendingReconnects: PendingReconnect[];

  /**
   * "declined" | "plan" | "interrupted" | "" — why a failed run ended when it
   * was not an ordinary step failure (WF-34).
   *
   * @generated from field: string end_reason = 16;
   */
  endReason: string;

  /**
   * the run-error step's limit, when failed (LIMIT-14)
   *
   * @generated from field: lvdr.v2.errors.LimitDetail limit = 17;
   */
  limit?: LimitDetail | undefined;
};

/**
 * Describes the message lvdr.v2.workflow.WorkflowInstanceSummary.
 * Use `create(WorkflowInstanceSummarySchema)` to create a new message.
 */
export const WorkflowInstanceSummarySchema: GenMessage<WorkflowInstanceSummary> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 1);

/**
 * PendingReconnect is one `reconnect` step blocking a suspended run (AON-06).
 *
 * @generated from message lvdr.v2.workflow.PendingReconnect
 */
export type PendingReconnect = Message<"lvdr.v2.workflow.PendingReconnect"> & {
  /**
   * @generated from field: string step_id = 1;
   */
  stepId: string;

  /**
   * @generated from field: string connector_id = 2;
   */
  connectorId: string;
};

/**
 * Describes the message lvdr.v2.workflow.PendingReconnect.
 * Use `create(PendingReconnectSchema)` to create a new message.
 */
export const PendingReconnectSchema: GenMessage<PendingReconnect> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 2);

/**
 * PendingApproval is one `approval` step blocking a suspended run.
 *
 * @generated from message lvdr.v2.workflow.PendingApproval
 */
export type PendingApproval = Message<"lvdr.v2.workflow.PendingApproval"> & {
  /**
   * @generated from field: string step_id = 1;
   */
  stepId: string;

  /**
   * operator-facing text from the step's config
   *
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * the suspended step's type ("approval", "connector", "mcp", "agent"); "" on suspensions stored before WF-34
   *
   * @generated from field: string step_type = 3;
   */
  stepType: string;
};

/**
 * Describes the message lvdr.v2.workflow.PendingApproval.
 * Use `create(PendingApprovalSchema)` to create a new message.
 */
export const PendingApprovalSchema: GenMessage<PendingApproval> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 3);

/**
 * StepSummary is one step of a run, as the client sees it.
 *
 * Populated on the SINGLE-INSTANCE response only. The list response clamps at
 * perPage=100 (ws_handler.go) and a submit_graph spec is capped at
 * MaxSpecSteps=50, so per-step data there is ~750 KB of metadata alone before
 * any output. A PERSISTED workflow has NO step cap (run_spec.go:14-18 says so
 * explicitly), so one run is bounded by the server's per-instance byte budget
 * (boot/workflow's maxInstanceOutputBytes), NOT by construction — the metadata
 * of an unbounded step count is the residual, and it is metadata only.
 *
 * (The 1 MiB in internal/websocket/handler.go is SetReadLimit — the limit on
 * messages read FROM the peer. Nothing truncates an outbound frame, so an
 * oversized response is a slow client, not an error. The caps below are sized
 * for a reader, not for that limit.)
 *
 * `name` carries the step ID: StepSpec has no Name field.
 *
 * `output` is a JSON STRING, not a Struct, deliberately. It is capped
 * server-side, and a capped payload is not valid JSON — a structured field would
 * force the server to drop it entirely at the cap, which is the silent failure
 * this message exists to fix. `output_truncated` / `error_truncated` each cover
 * a clip OR a full drop of their own field.
 *
 * `output` and `error` are sanitised (utf8util.ToValidUTF8) and truncated
 * (utf8util.TruncateBytes) server-side. proto3 string fields REJECT invalid
 * UTF-8 at marshal time, and internal/websocket/handler.go drops a reply it
 * cannot marshal with NO error envelope — so one unsanitised byte from an
 * api_call step's remote response body hangs the client for 30 s, on every
 * retry, for that workflow.
 *
 * @generated from message lvdr.v2.workflow.StepSummary
 */
export type StepSummary = Message<"lvdr.v2.workflow.StepSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * the step id; StepSpec has no display name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * from the spec; "" when unknown
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * pending|ready|running|suspended|completed|failed|skipped, plus two
   * WIRE-ONLY values the engine never persists:
   *   abandoned — running|suspended when the run reached a terminal state, i.e.
   *               in flight when the run was cancelled or aborted. NOT skipped:
   *               skipped reads as "a condition routed around this", which is
   *               the one thing that did not happen.
   *   unknown   — a result row present with a null value (schema drift / a
   *               hand-repaired record). Better than an empty badge.
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * RFC3339; empty if not started
   *
   * @generated from field: string started_at = 5;
   */
  startedAt: string;

  /**
   * RFC3339; empty if not finished
   *
   * @generated from field: string finished_at = 6;
   */
  finishedAt: string;

  /**
   * 0 if not finished
   *
   * @generated from field: int64 duration_ms = 7;
   */
  durationMs: bigint;

  /**
   * sanitised, capped
   *
   * @generated from field: string error = 8;
   */
  error: string;

  /**
   * sanitised, capped, raw JSON
   *
   * @generated from field: string output = 9;
   */
  output: string;

  /**
   * `output` was clipped or dropped
   *
   * @generated from field: bool output_truncated = 10;
   */
  outputTruncated: boolean;

  /**
   * `error` was clipped or dropped. SEPARATE from output_truncated: one flag
   * for both made a step whose error was clipped and which produced no output
   * render an "Output was shortened" notice with no output beneath it — telling
   * the user something was lost from a field that was never populated, and
   * saying nothing about the field that actually lost bytes.
   *
   * @generated from field: bool error_truncated = 11;
   */
  errorTruncated: boolean;

  /**
   * Why a skipped step was skipped (WF-35); all three empty when unknown — a
   * step that is not skipped, or a run stored before WF-35.
   *   skip_kind   — dependency_skipped | condition_branch | cancelled
   *   skip_step   — the skipped dependency, or the condition that routed away
   *   skip_branch — the branch the condition took: "true" | "false"
   *
   * @generated from field: string skip_kind = 12;
   */
  skipKind: string;

  /**
   * @generated from field: string skip_step = 13;
   */
  skipStep: string;

  /**
   * @generated from field: string skip_branch = 14;
   */
  skipBranch: string;

  /**
   * a refusal's numbers; absent = not a limit failure (LIMIT-14)
   *
   * @generated from field: lvdr.v2.errors.LimitDetail limit = 15;
   */
  limit?: LimitDetail | undefined;

  /**
   * what the step cut (its output's truncated key)
   *
   * @generated from field: repeated lvdr.v2.errors.LimitCut truncated = 16;
   */
  truncated: LimitCut[];
};

/**
 * Describes the message lvdr.v2.workflow.StepSummary.
 * Use `create(StepSummarySchema)` to create a new message.
 */
export const StepSummarySchema: GenMessage<StepSummary> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 4);

/**
 * --- CreateWorkflow ---
 *
 * @generated from message lvdr.v2.workflow.CreateWorkflowRequest
 */
export type CreateWorkflowRequest = Message<"lvdr.v2.workflow.CreateWorkflowRequest"> & {
  /**
   * opaque JSON/YAML — parsed server-side
   *
   * @generated from field: bytes workflow_spec = 1;
   */
  workflowSpec: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workflow.CreateWorkflowRequest.
 * Use `create(CreateWorkflowRequestSchema)` to create a new message.
 */
export const CreateWorkflowRequestSchema: GenMessage<CreateWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 5);

/**
 * @generated from message lvdr.v2.workflow.CreateWorkflowResponse
 */
export type CreateWorkflowResponse = Message<"lvdr.v2.workflow.CreateWorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * One-time secret reveal for triggers whose bearer token / HMAC secret was
   * minted by THIS call (library-ingest-tools 2026-07-04). The plaintext is
   * scrubbed server-side immediately after registration — file-mode webhook
   * tokens are UNRECOVERABLE afterwards (hash-only at rest, by design) — so
   * this response is the only place a client can ever read them.
   *
   * @generated from field: repeated lvdr.v2.workflow.TriggerSummary revealed_triggers = 2;
   */
  revealedTriggers: TriggerSummary[];
};

/**
 * Describes the message lvdr.v2.workflow.CreateWorkflowResponse.
 * Use `create(CreateWorkflowResponseSchema)` to create a new message.
 */
export const CreateWorkflowResponseSchema: GenMessage<CreateWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 6);

/**
 * --- ListWorkflows ---
 *
 * @generated from message lvdr.v2.workflow.ListWorkflowsRequest
 */
export type ListWorkflowsRequest = Message<"lvdr.v2.workflow.ListWorkflowsRequest"> & {
};

/**
 * Describes the message lvdr.v2.workflow.ListWorkflowsRequest.
 * Use `create(ListWorkflowsRequestSchema)` to create a new message.
 */
export const ListWorkflowsRequestSchema: GenMessage<ListWorkflowsRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 7);

/**
 * @generated from message lvdr.v2.workflow.ListWorkflowsResponse
 */
export type ListWorkflowsResponse = Message<"lvdr.v2.workflow.ListWorkflowsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.WorkflowSummary workflows = 1;
   */
  workflows: WorkflowSummary[];
};

/**
 * Describes the message lvdr.v2.workflow.ListWorkflowsResponse.
 * Use `create(ListWorkflowsResponseSchema)` to create a new message.
 */
export const ListWorkflowsResponseSchema: GenMessage<ListWorkflowsResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 8);

/**
 * --- GetWorkflow (with optional draft view) ---
 *
 * @generated from message lvdr.v2.workflow.GetWorkflowRequest
 */
export type GetWorkflowRequest = Message<"lvdr.v2.workflow.GetWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * true → return draft view if any, else 404
   *
   * @generated from field: bool draft = 2;
   */
  draft: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.GetWorkflowRequest.
 * Use `create(GetWorkflowRequestSchema)` to create a new message.
 */
export const GetWorkflowRequestSchema: GenMessage<GetWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 9);

/**
 * @generated from message lvdr.v2.workflow.WorkflowResponse
 */
export type WorkflowResponse = Message<"lvdr.v2.workflow.WorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * opaque — same format as CreateWorkflowRequest
   *
   * @generated from field: bytes workflow_spec = 2;
   */
  workflowSpec: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workflow.WorkflowResponse.
 * Use `create(WorkflowResponseSchema)` to create a new message.
 */
export const WorkflowResponseSchema: GenMessage<WorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 10);

/**
 * --- UpdateWorkflow (auto-routes to draft if deployed) ---
 *
 * @generated from message lvdr.v2.workflow.UpdateWorkflowRequest
 */
export type UpdateWorkflowRequest = Message<"lvdr.v2.workflow.UpdateWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: bytes workflow_spec = 2;
   */
  workflowSpec: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workflow.UpdateWorkflowRequest.
 * Use `create(UpdateWorkflowRequestSchema)` to create a new message.
 */
export const UpdateWorkflowRequestSchema: GenMessage<UpdateWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 11);

/**
 * "updated" → live spec updated in-place. "draft_created" → workflow was
 * deployed so the update was persisted as a draft; caller can publish it
 * later via PublishWorkflowRequest.
 *
 * @generated from message lvdr.v2.workflow.UpdateWorkflowResponse
 */
export type UpdateWorkflowResponse = Message<"lvdr.v2.workflow.UpdateWorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * "updated" | "draft_created"
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * issues are the warnings of an accepted save (WF-38); a refused save
   * carries its error issues on ErrorEvent.issues instead.
   *
   * @generated from field: repeated lvdr.v2.errors.ValidationIssue issues = 3;
   */
  issues: ValidationIssue[];
};

/**
 * Describes the message lvdr.v2.workflow.UpdateWorkflowResponse.
 * Use `create(UpdateWorkflowResponseSchema)` to create a new message.
 */
export const UpdateWorkflowResponseSchema: GenMessage<UpdateWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 12);

/**
 * --- DeleteWorkflow ---
 *
 * @generated from message lvdr.v2.workflow.DeleteWorkflowRequest
 */
export type DeleteWorkflowRequest = Message<"lvdr.v2.workflow.DeleteWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteWorkflowRequest.
 * Use `create(DeleteWorkflowRequestSchema)` to create a new message.
 */
export const DeleteWorkflowRequestSchema: GenMessage<DeleteWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 13);

/**
 * @generated from message lvdr.v2.workflow.DeleteWorkflowResponse
 */
export type DeleteWorkflowResponse = Message<"lvdr.v2.workflow.DeleteWorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteWorkflowResponse.
 * Use `create(DeleteWorkflowResponseSchema)` to create a new message.
 */
export const DeleteWorkflowResponseSchema: GenMessage<DeleteWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 14);

/**
 * --- RunWorkflow ---
 *
 * @generated from message lvdr.v2.workflow.RunWorkflowRequest
 */
export type RunWorkflowRequest = Message<"lvdr.v2.workflow.RunWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * opaque trigger payload; JSON on the wire today
   *
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workflow.RunWorkflowRequest.
 * Use `create(RunWorkflowRequestSchema)` to create a new message.
 */
export const RunWorkflowRequestSchema: GenMessage<RunWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 15);

/**
 * @generated from message lvdr.v2.workflow.RunWorkflowResponse
 */
export type RunWorkflowResponse = Message<"lvdr.v2.workflow.RunWorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;
};

/**
 * Describes the message lvdr.v2.workflow.RunWorkflowResponse.
 * Use `create(RunWorkflowResponseSchema)` to create a new message.
 */
export const RunWorkflowResponseSchema: GenMessage<RunWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 16);

/**
 * --- PublishWorkflow (draft → live) ---
 *
 * @generated from message lvdr.v2.workflow.PublishWorkflowRequest
 */
export type PublishWorkflowRequest = Message<"lvdr.v2.workflow.PublishWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.workflow.PublishWorkflowRequest.
 * Use `create(PublishWorkflowRequestSchema)` to create a new message.
 */
export const PublishWorkflowRequestSchema: GenMessage<PublishWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 17);

/**
 * @generated from message lvdr.v2.workflow.PublishWorkflowResponse
 */
export type PublishWorkflowResponse = Message<"lvdr.v2.workflow.PublishWorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * One-time reveal for triggers newly minted by this publish (see
   * CreateWorkflowResponse.revealed_triggers). Config edits to existing
   * file-mode triggers carry the old credential forward and reveal nothing.
   *
   * @generated from field: repeated lvdr.v2.workflow.TriggerSummary revealed_triggers = 2;
   */
  revealedTriggers: TriggerSummary[];
};

/**
 * Describes the message lvdr.v2.workflow.PublishWorkflowResponse.
 * Use `create(PublishWorkflowResponseSchema)` to create a new message.
 */
export const PublishWorkflowResponseSchema: GenMessage<PublishWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 18);

/**
 * --- DeployWorkflow (activate / deactivate triggers) ---
 *
 * @generated from message lvdr.v2.workflow.DeployWorkflowRequest
 */
export type DeployWorkflowRequest = Message<"lvdr.v2.workflow.DeployWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: bool active = 2;
   */
  active: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.DeployWorkflowRequest.
 * Use `create(DeployWorkflowRequestSchema)` to create a new message.
 */
export const DeployWorkflowRequestSchema: GenMessage<DeployWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 19);

/**
 * @generated from message lvdr.v2.workflow.DeployWorkflowResponse
 */
export type DeployWorkflowResponse = Message<"lvdr.v2.workflow.DeployWorkflowResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: bool active = 2;
   */
  active: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.DeployWorkflowResponse.
 * Use `create(DeployWorkflowResponseSchema)` to create a new message.
 */
export const DeployWorkflowResponseSchema: GenMessage<DeployWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 20);

/**
 * --- DeleteWorkflowDraft ---
 *
 * @generated from message lvdr.v2.workflow.DeleteWorkflowDraftRequest
 */
export type DeleteWorkflowDraftRequest = Message<"lvdr.v2.workflow.DeleteWorkflowDraftRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteWorkflowDraftRequest.
 * Use `create(DeleteWorkflowDraftRequestSchema)` to create a new message.
 */
export const DeleteWorkflowDraftRequestSchema: GenMessage<DeleteWorkflowDraftRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 21);

/**
 * @generated from message lvdr.v2.workflow.DeleteWorkflowDraftResponse
 */
export type DeleteWorkflowDraftResponse = Message<"lvdr.v2.workflow.DeleteWorkflowDraftResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteWorkflowDraftResponse.
 * Use `create(DeleteWorkflowDraftResponseSchema)` to create a new message.
 */
export const DeleteWorkflowDraftResponseSchema: GenMessage<DeleteWorkflowDraftResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 22);

/**
 * @generated from message lvdr.v2.workflow.ApproveWorkflowStepRequest
 */
export type ApproveWorkflowStepRequest = Message<"lvdr.v2.workflow.ApproveWorkflowStepRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;

  /**
   * @generated from field: string step_id = 3;
   */
  stepId: string;

  /**
   * opaque decision payload
   *
   * @generated from field: bytes approval_data = 4;
   */
  approvalData: Uint8Array;

  /**
   * release defaults to ONCE, so existing clients need no migration.
   *
   * @generated from field: lvdr.v2.workflow.SendRelease release = 5;
   */
  release: SendRelease;

  /**
   * grant_ttl_seconds bounds a NEXT_RUN grant. Zero means the server default
   * (24h). Ignored for ONCE/ALWAYS. Clamped server-side — a client must not be
   * able to mint a grant that outlives the consent behind it.
   *
   * @generated from field: uint32 grant_ttl_seconds = 6;
   */
  grantTtlSeconds: number;
};

/**
 * Describes the message lvdr.v2.workflow.ApproveWorkflowStepRequest.
 * Use `create(ApproveWorkflowStepRequestSchema)` to create a new message.
 */
export const ApproveWorkflowStepRequestSchema: GenMessage<ApproveWorkflowStepRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 23);

/**
 * @generated from message lvdr.v2.workflow.ApproveWorkflowStepResponse
 */
export type ApproveWorkflowStepResponse = Message<"lvdr.v2.workflow.ApproveWorkflowStepResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;

  /**
   * @generated from field: string step_id = 3;
   */
  stepId: string;

  /**
   * "approved"
   *
   * @generated from field: string status = 4;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workflow.ApproveWorkflowStepResponse.
 * Use `create(ApproveWorkflowStepResponseSchema)` to create a new message.
 */
export const ApproveWorkflowStepResponseSchema: GenMessage<ApproveWorkflowStepResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 24);

/**
 * --- AON-06: resume a step suspended on a reconnect ---
 *
 * @generated from message lvdr.v2.workflow.ResumeReconnectWorkflowStepRequest
 */
export type ResumeReconnectWorkflowStepRequest = Message<"lvdr.v2.workflow.ResumeReconnectWorkflowStepRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;

  /**
   * @generated from field: string step_id = 3;
   */
  stepId: string;
};

/**
 * Describes the message lvdr.v2.workflow.ResumeReconnectWorkflowStepRequest.
 * Use `create(ResumeReconnectWorkflowStepRequestSchema)` to create a new message.
 */
export const ResumeReconnectWorkflowStepRequestSchema: GenMessage<ResumeReconnectWorkflowStepRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 25);

/**
 * @generated from message lvdr.v2.workflow.ResumeReconnectWorkflowStepResponse
 */
export type ResumeReconnectWorkflowStepResponse = Message<"lvdr.v2.workflow.ResumeReconnectWorkflowStepResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;

  /**
   * @generated from field: string step_id = 3;
   */
  stepId: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workflow.ResumeReconnectWorkflowStepResponse.
 * Use `create(ResumeReconnectWorkflowStepResponseSchema)` to create a new message.
 */
export const ResumeReconnectWorkflowStepResponseSchema: GenMessage<ResumeReconnectWorkflowStepResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 26);

/**
 * --- ListWorkflowInstances (paginated) ---
 *
 * @generated from message lvdr.v2.workflow.ListWorkflowInstancesRequest
 */
export type ListWorkflowInstancesRequest = Message<"lvdr.v2.workflow.ListWorkflowInstancesRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * 1-indexed, default 1
   *
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * default 20, capped 1-100
   *
   * @generated from field: int32 per_page = 3;
   */
  perPage: number;
};

/**
 * Describes the message lvdr.v2.workflow.ListWorkflowInstancesRequest.
 * Use `create(ListWorkflowInstancesRequestSchema)` to create a new message.
 */
export const ListWorkflowInstancesRequestSchema: GenMessage<ListWorkflowInstancesRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 27);

/**
 * @generated from message lvdr.v2.workflow.ListWorkflowInstancesResponse
 */
export type ListWorkflowInstancesResponse = Message<"lvdr.v2.workflow.ListWorkflowInstancesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.WorkflowInstanceSummary instances = 1;
   */
  instances: WorkflowInstanceSummary[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 per_page = 4;
   */
  perPage: number;
};

/**
 * Describes the message lvdr.v2.workflow.ListWorkflowInstancesResponse.
 * Use `create(ListWorkflowInstancesResponseSchema)` to create a new message.
 */
export const ListWorkflowInstancesResponseSchema: GenMessage<ListWorkflowInstancesResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 28);

/**
 * --- GetWorkflowInstance ---
 *
 * @generated from message lvdr.v2.workflow.GetWorkflowInstanceRequest
 */
export type GetWorkflowInstanceRequest = Message<"lvdr.v2.workflow.GetWorkflowInstanceRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;
};

/**
 * Describes the message lvdr.v2.workflow.GetWorkflowInstanceRequest.
 * Use `create(GetWorkflowInstanceRequestSchema)` to create a new message.
 */
export const GetWorkflowInstanceRequestSchema: GenMessage<GetWorkflowInstanceRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 29);

/**
 * @generated from message lvdr.v2.workflow.WorkflowInstanceResponse
 */
export type WorkflowInstanceResponse = Message<"lvdr.v2.workflow.WorkflowInstanceResponse"> & {
  /**
   * @generated from field: lvdr.v2.workflow.WorkflowInstanceSummary instance = 1;
   */
  instance?: WorkflowInstanceSummary | undefined;
};

/**
 * Describes the message lvdr.v2.workflow.WorkflowInstanceResponse.
 * Use `create(WorkflowInstanceResponseSchema)` to create a new message.
 */
export const WorkflowInstanceResponseSchema: GenMessage<WorkflowInstanceResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 30);

/**
 * --- CancelWorkflowInstance ---
 *
 * @generated from message lvdr.v2.workflow.CancelWorkflowInstanceRequest
 */
export type CancelWorkflowInstanceRequest = Message<"lvdr.v2.workflow.CancelWorkflowInstanceRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;
};

/**
 * Describes the message lvdr.v2.workflow.CancelWorkflowInstanceRequest.
 * Use `create(CancelWorkflowInstanceRequestSchema)` to create a new message.
 */
export const CancelWorkflowInstanceRequestSchema: GenMessage<CancelWorkflowInstanceRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 31);

/**
 * @generated from message lvdr.v2.workflow.CancelWorkflowInstanceResponse
 */
export type CancelWorkflowInstanceResponse = Message<"lvdr.v2.workflow.CancelWorkflowInstanceResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string instance_id = 2;
   */
  instanceId: string;

  /**
   * "cancelled"
   *
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workflow.CancelWorkflowInstanceResponse.
 * Use `create(CancelWorkflowInstanceResponseSchema)` to create a new message.
 */
export const CancelWorkflowInstanceResponseSchema: GenMessage<CancelWorkflowInstanceResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 32);

/**
 * TriggerSummary is one trigger attached to a workflow. email_address,
 * signing_secret and webhook_token are ONE-TIME reveal fields — populated only
 * on create, never on list/update. Frontend must capture them from the create
 * response or they're gone. List returns them as empty strings.
 *
 * @generated from message lvdr.v2.workflow.TriggerSummary
 */
export type TriggerSummary = Message<"lvdr.v2.workflow.TriggerSummary"> & {
  /**
   * @generated from field: string trigger_id = 1;
   */
  triggerId: string;

  /**
   * "cron" | "webhook" | "email" | "file"
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: bool active = 3;
   */
  active: boolean;

  /**
   * cron expression
   *
   * @generated from field: string schedule = 4;
   */
  schedule: string;

  /**
   * @generated from field: string hook_id = 5;
   */
  hookId: string;

  /**
   * @generated from field: string file_hook = 6;
   */
  fileHook: string;

  /**
   * create-only
   *
   * @generated from field: string email_address = 7;
   */
  emailAddress: string;

  /**
   * create-only
   *
   * @generated from field: string signing_secret = 8;
   */
  signingSecret: string;

  /**
   * RFC3339, empty if never
   *
   * @generated from field: string last_fired = 9;
   */
  lastFired: string;

  /**
   * RFC3339, empty if not scheduled
   *
   * @generated from field: string next_fire = 10;
   */
  nextFire: string;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 11;
   */
  createdAt: string;

  /**
   * create-only (Phase 3.1 mandatory bearer token)
   *
   * @generated from field: string webhook_token = 12;
   */
  webhookToken: string;

  /**
   * "" | "ingest" | "ephemeral" — file-ingestion webhook (library-ingest-tools)
   *
   * @generated from field: string file_mode = 13;
   */
  fileMode: string;
};

/**
 * Describes the message lvdr.v2.workflow.TriggerSummary.
 * Use `create(TriggerSummarySchema)` to create a new message.
 */
export const TriggerSummarySchema: GenMessage<TriggerSummary> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 33);

/**
 * TriggerHistoryRecord — one firing of a trigger. 7-day retention on
 * the backend.
 *
 * @generated from message lvdr.v2.workflow.TriggerHistoryRecord
 */
export type TriggerHistoryRecord = Message<"lvdr.v2.workflow.TriggerHistoryRecord"> & {
  /**
   * @generated from field: string trigger_id = 1;
   */
  triggerId: string;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * empty if skipped / dedup
   *
   * @generated from field: string instance_id = 3;
   */
  instanceId: string;

  /**
   * "success" | "failed" | "skipped-dedup" | "refused:budget" |
   * "skipped:still-running" | "skipped:below-floor" | "duplicate" |
   * "fired:dedup-unavailable" (and the gate refusals in trigger_history.go)
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * RFC3339
   *
   * @generated from field: string fired_at = 5;
   */
  firedAt: string;

  /**
   * @generated from field: int64 duration_ms = 6;
   */
  durationMs: bigint;

  /**
   * empty on success
   *
   * @generated from field: string error = 7;
   */
  error: string;

  /**
   * detail carries the numbers a refusal enforced ("limit", "window",
   * "floor", "interval") so the UI can render them (WF-38).
   *
   * @generated from field: map<string, string> detail = 8;
   */
  detail: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.workflow.TriggerHistoryRecord.
 * Use `create(TriggerHistoryRecordSchema)` to create a new message.
 */
export const TriggerHistoryRecordSchema: GenMessage<TriggerHistoryRecord> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 34);

/**
 * --- ListTriggers ---
 *
 * @generated from message lvdr.v2.workflow.ListTriggersRequest
 */
export type ListTriggersRequest = Message<"lvdr.v2.workflow.ListTriggersRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message lvdr.v2.workflow.ListTriggersRequest.
 * Use `create(ListTriggersRequestSchema)` to create a new message.
 */
export const ListTriggersRequestSchema: GenMessage<ListTriggersRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 35);

/**
 * @generated from message lvdr.v2.workflow.ListTriggersResponse
 */
export type ListTriggersResponse = Message<"lvdr.v2.workflow.ListTriggersResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.TriggerSummary triggers = 1;
   */
  triggers: TriggerSummary[];
};

/**
 * Describes the message lvdr.v2.workflow.ListTriggersResponse.
 * Use `create(ListTriggersResponseSchema)` to create a new message.
 */
export const ListTriggersResponseSchema: GenMessage<ListTriggersResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 36);

/**
 * CronTriggerConfig — a scheduled (cron) start event.
 *
 * @generated from message lvdr.v2.workflow.CronTriggerConfig
 */
export type CronTriggerConfig = Message<"lvdr.v2.workflow.CronTriggerConfig"> & {
  /**
   * 6-field cron with seconds
   *
   * @generated from field: string schedule = 1;
   */
  schedule: string;
};

/**
 * Describes the message lvdr.v2.workflow.CronTriggerConfig.
 * Use `create(CronTriggerConfigSchema)` to create a new message.
 */
export const CronTriggerConfigSchema: GenMessage<CronTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 37);

/**
 * WebhookTriggerConfig — an inbound HTTP webhook start event. Mandatorily
 * authenticated (per-trigger token + optional HMAC); fail-closed at Build.
 *
 * @generated from message lvdr.v2.workflow.WebhookTriggerConfig
 */
export type WebhookTriggerConfig = Message<"lvdr.v2.workflow.WebhookTriggerConfig"> & {
  /**
   * verify an HMAC signature header too
   *
   * @generated from field: bool require_hmac = 1;
   */
  requireHmac: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.WebhookTriggerConfig.
 * Use `create(WebhookTriggerConfigSchema)` to create a new message.
 */
export const WebhookTriggerConfigSchema: GenMessage<WebhookTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 38);

/**
 * FileTriggerConfig — fires on a file upload (raw bytes or post-index markdown).
 *
 * @generated from message lvdr.v2.workflow.FileTriggerConfig
 */
export type FileTriggerConfig = Message<"lvdr.v2.workflow.FileTriggerConfig"> & {
  /**
   * "raw" | "indexed"
   *
   * @generated from field: string file_hook = 1;
   */
  fileHook: string;

  /**
   * zero value = do not fire on files a workflow wrote (WF-36)
   *
   * @generated from field: bool allow_workflow_authored = 2;
   */
  allowWorkflowAuthored: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.FileTriggerConfig.
 * Use `create(FileTriggerConfigSchema)` to create a new message.
 */
export const FileTriggerConfigSchema: GenMessage<FileTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 39);

/**
 * EmailTriggerConfig — fires on an inbound email to the per-trigger address.
 *
 * @generated from message lvdr.v2.workflow.EmailTriggerConfig
 */
export type EmailTriggerConfig = Message<"lvdr.v2.workflow.EmailTriggerConfig"> & {
  /**
   * optional; compiled at Build
   *
   * @generated from field: string subject_regex = 1;
   */
  subjectRegex: string;

  /**
   * @generated from field: repeated string sender_allowlist = 2;
   */
  senderAllowlist: string[];
};

/**
 * Describes the message lvdr.v2.workflow.EmailTriggerConfig.
 * Use `create(EmailTriggerConfigSchema)` to create a new message.
 */
export const EmailTriggerConfigSchema: GenMessage<EmailTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 40);

/**
 * RecordingTriggerConfig — fires when an opted-in recording finishes
 * transcription (R22). opt_in is the per-workflow consent key (the bug the
 * triggers-v2 effort fixes — it must survive into the registry).
 *
 * @generated from message lvdr.v2.workflow.RecordingTriggerConfig
 */
export type RecordingTriggerConfig = Message<"lvdr.v2.workflow.RecordingTriggerConfig"> & {
  /**
   * per-workflow consent; default false
   *
   * @generated from field: bool opt_in = 1;
   */
  optIn: boolean;

  /**
   * match any of these recording tags
   *
   * @generated from field: repeated string tags_any = 2;
   */
  tagsAny: string[];

  /**
   * optional; compiled at Build
   *
   * @generated from field: string title_regex = 3;
   */
  titleRegex: string;
};

/**
 * Describes the message lvdr.v2.workflow.RecordingTriggerConfig.
 * Use `create(RecordingTriggerConfigSchema)` to create a new message.
 */
export const RecordingTriggerConfigSchema: GenMessage<RecordingTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 41);

/**
 * ChatTriggerConfig — fires on an inbound chat message on a connected workspace.
 *
 * @generated from message lvdr.v2.workflow.ChatTriggerConfig
 */
export type ChatTriggerConfig = Message<"lvdr.v2.workflow.ChatTriggerConfig"> & {
  /**
   * cheap pre-attention substring gate
   *
   * @generated from field: repeated string keyword_any = 1;
   */
  keywordAny: string[];

  /**
   * @generated from field: repeated string channel_allowlist = 2;
   */
  channelAllowlist: string[];
};

/**
 * Describes the message lvdr.v2.workflow.ChatTriggerConfig.
 * Use `create(ChatTriggerConfigSchema)` to create a new message.
 */
export const ChatTriggerConfigSchema: GenMessage<ChatTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 42);

/**
 * ManualTriggerConfig — a contextual manual start event: a labeled button on a
 * domain surface that fires with the object's server-resolved payload.
 *
 * @generated from message lvdr.v2.workflow.ManualTriggerConfig
 */
export type ManualTriggerConfig = Message<"lvdr.v2.workflow.ManualTriggerConfig"> & {
  /**
   * ContextSurface id, e.g. "recording-transcript"
   *
   * @generated from field: string surface = 1;
   */
  surface: string;

  /**
   * button label
   *
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.workflow.ManualTriggerConfig.
 * Use `create(ManualTriggerConfigSchema)` to create a new message.
 */
export const ManualTriggerConfigSchema: GenMessage<ManualTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 43);

/**
 * ResearchTriggerConfig — fires when a research run reaches a terminal COMPLETED
 * state (WFEV-02). A partial completion does NOT fire unless include_partial.
 *
 * @generated from message lvdr.v2.workflow.ResearchTriggerConfig
 */
export type ResearchTriggerConfig = Message<"lvdr.v2.workflow.ResearchTriggerConfig"> & {
  /**
   * also fire on ResearchCompletedPartial
   *
   * @generated from field: bool include_partial = 1;
   */
  includePartial: boolean;

  /**
   * @generated from field: repeated string tags_any = 2;
   */
  tagsAny: string[];
};

/**
 * Describes the message lvdr.v2.workflow.ResearchTriggerConfig.
 * Use `create(ResearchTriggerConfigSchema)` to create a new message.
 */
export const ResearchTriggerConfigSchema: GenMessage<ResearchTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 44);

/**
 * NoteTriggerConfig — fires when a note is created (WFEV-03).
 *
 * allow_workflow_authored is a PLAIN bool on purpose: its zero value (false) is
 * the SAFE setting, so an omitted field, a row predating it and an unchecked box
 * all mean "do not fire on notes a workflow wrote" — which is what closes the
 * write->trigger->write loop. Do NOT invert it to an exclude_* flag: that makes
 * the zero value unsafe and forces a tri-state the FE checkbox cannot represent
 * (TriggerField has no default; asBool(v) = v === true). See design D6 rev 2.
 *
 * @generated from message lvdr.v2.workflow.NoteTriggerConfig
 */
export type NoteTriggerConfig = Message<"lvdr.v2.workflow.NoteTriggerConfig"> & {
  /**
   * @generated from field: repeated string folder_any = 1;
   */
  folderAny: string[];

  /**
   * @generated from field: repeated string tags_any = 2;
   */
  tagsAny: string[];

  /**
   * @generated from field: bool allow_workflow_authored = 3;
   */
  allowWorkflowAuthored: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.NoteTriggerConfig.
 * Use `create(NoteTriggerConfigSchema)` to create a new message.
 */
export const NoteTriggerConfigSchema: GenMessage<NoteTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 45);

/**
 * EventTriggerConfig — DEPRECATED (WFEV-01). The `event` trigger never had an
 * emitter; superseded by the typed research/note triggers. Retained so stored
 * specs still parse during the migration window. Do not add new uses.
 *
 * @generated from message lvdr.v2.workflow.EventTriggerConfig
 * @deprecated
 */
export type EventTriggerConfig = Message<"lvdr.v2.workflow.EventTriggerConfig"> & {
  /**
   * from the (removed) curated set
   *
   * @generated from field: string event_name = 1;
   */
  eventName: string;
};

/**
 * Describes the message lvdr.v2.workflow.EventTriggerConfig.
 * Use `create(EventTriggerConfigSchema)` to create a new message.
 * @deprecated
 */
export const EventTriggerConfigSchema: GenMessage<EventTriggerConfig> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 46);

/**
 * TriggerSpec is one typed start-event config. Exactly one config oneof arm is
 * set, selected by `type`.
 *
 * @generated from message lvdr.v2.workflow.TriggerSpec
 */
export type TriggerSpec = Message<"lvdr.v2.workflow.TriggerSpec"> & {
  /**
   * mirrors the oneof arm (cron|webhook|...)
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: bool active = 2;
   */
  active: boolean;

  /**
   * @generated from oneof lvdr.v2.workflow.TriggerSpec.config
   */
  config: {
    /**
     * @generated from field: lvdr.v2.workflow.CronTriggerConfig cron = 10;
     */
    value: CronTriggerConfig;
    case: "cron";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.WebhookTriggerConfig webhook = 11;
     */
    value: WebhookTriggerConfig;
    case: "webhook";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.FileTriggerConfig file = 12;
     */
    value: FileTriggerConfig;
    case: "file";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.EmailTriggerConfig email = 13;
     */
    value: EmailTriggerConfig;
    case: "email";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.RecordingTriggerConfig recording = 14;
     */
    value: RecordingTriggerConfig;
    case: "recording";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ChatTriggerConfig chat = 15;
     */
    value: ChatTriggerConfig;
    case: "chat";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ManualTriggerConfig manual = 16;
     */
    value: ManualTriggerConfig;
    case: "manual";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.EventTriggerConfig event = 17 [deprecated = true];
     * @deprecated
     */
    value: EventTriggerConfig;
    case: "event";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.ResearchTriggerConfig research = 18;
     */
    value: ResearchTriggerConfig;
    case: "research";
  } | {
    /**
     * @generated from field: lvdr.v2.workflow.NoteTriggerConfig note = 19;
     */
    value: NoteTriggerConfig;
    case: "note";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message lvdr.v2.workflow.TriggerSpec.
 * Use `create(TriggerSpecSchema)` to create a new message.
 */
export const TriggerSpecSchema: GenMessage<TriggerSpec> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 47);

/**
 * --- CreateTrigger (typed — mirrors api.CreateTriggerRequest) ---
 *
 * @generated from message lvdr.v2.workflow.CreateTriggerRequest
 */
export type CreateTriggerRequest = Message<"lvdr.v2.workflow.CreateTriggerRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Fields 2-7 are the legacy flat trigger shape, kept for back-compat with
   * pre-v2 clients. New clients SHOULD send `spec` (field 8); when `spec` is
   * present the server reads the typed oneof and ignores 2-7. DEPRECATED.
   *
   * required (legacy)
   *
   * @generated from field: string type = 2 [deprecated = true];
   * @deprecated
   */
  type: string;

  /**
   * @generated from field: string schedule = 3 [deprecated = true];
   * @deprecated
   */
  schedule: string;

  /**
   * @generated from field: string file_hook = 4 [deprecated = true];
   * @deprecated
   */
  fileHook: string;

  /**
   * @generated from field: bool require_hmac = 5 [deprecated = true];
   * @deprecated
   */
  requireHmac: boolean;

  /**
   * @generated from field: repeated string sender_allowlist = 6 [deprecated = true];
   * @deprecated
   */
  senderAllowlist: string[];

  /**
   * @generated from field: string subject_regex = 7 [deprecated = true];
   * @deprecated
   */
  subjectRegex: string;

  /**
   * v2 typed trigger config
   *
   * @generated from field: optional lvdr.v2.workflow.TriggerSpec spec = 8;
   */
  spec?: TriggerSpec | undefined;
};

/**
 * Describes the message lvdr.v2.workflow.CreateTriggerRequest.
 * Use `create(CreateTriggerRequestSchema)` to create a new message.
 */
export const CreateTriggerRequestSchema: GenMessage<CreateTriggerRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 48);

/**
 * @generated from message lvdr.v2.workflow.TriggerResponse
 */
export type TriggerResponse = Message<"lvdr.v2.workflow.TriggerResponse"> & {
  /**
   * on create, includes one-time secrets
   *
   * @generated from field: lvdr.v2.workflow.TriggerSummary trigger = 1;
   */
  trigger?: TriggerSummary | undefined;
};

/**
 * Describes the message lvdr.v2.workflow.TriggerResponse.
 * Use `create(TriggerResponseSchema)` to create a new message.
 */
export const TriggerResponseSchema: GenMessage<TriggerResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 49);

/**
 * --- UpdateTrigger ---
 *
 * @generated from message lvdr.v2.workflow.UpdateTriggerRequest
 */
export type UpdateTriggerRequest = Message<"lvdr.v2.workflow.UpdateTriggerRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string trigger_id = 2;
   */
  triggerId: string;

  /**
   * Optionals — use proto3 optional so the frontend can distinguish
   * "don't change" from "set to the zero value."
   *
   * @generated from field: optional bool active = 3;
   */
  active?: boolean | undefined;

  /**
   * @generated from field: optional string schedule = 4;
   */
  schedule?: string | undefined;
};

/**
 * Describes the message lvdr.v2.workflow.UpdateTriggerRequest.
 * Use `create(UpdateTriggerRequestSchema)` to create a new message.
 */
export const UpdateTriggerRequestSchema: GenMessage<UpdateTriggerRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 50);

/**
 * --- DeleteTrigger ---
 *
 * @generated from message lvdr.v2.workflow.DeleteTriggerRequest
 */
export type DeleteTriggerRequest = Message<"lvdr.v2.workflow.DeleteTriggerRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string trigger_id = 2;
   */
  triggerId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteTriggerRequest.
 * Use `create(DeleteTriggerRequestSchema)` to create a new message.
 */
export const DeleteTriggerRequestSchema: GenMessage<DeleteTriggerRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 51);

/**
 * @generated from message lvdr.v2.workflow.DeleteTriggerResponse
 */
export type DeleteTriggerResponse = Message<"lvdr.v2.workflow.DeleteTriggerResponse"> & {
  /**
   * @generated from field: string trigger_id = 1;
   */
  triggerId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteTriggerResponse.
 * Use `create(DeleteTriggerResponseSchema)` to create a new message.
 */
export const DeleteTriggerResponseSchema: GenMessage<DeleteTriggerResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 52);

/**
 * --- GetTriggerHistory ---
 *
 * @generated from message lvdr.v2.workflow.GetTriggerHistoryRequest
 */
export type GetTriggerHistoryRequest = Message<"lvdr.v2.workflow.GetTriggerHistoryRequest"> & {
  /**
   * @generated from field: string trigger_id = 1;
   */
  triggerId: string;

  /**
   * default 50; capped 1..200
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message lvdr.v2.workflow.GetTriggerHistoryRequest.
 * Use `create(GetTriggerHistoryRequestSchema)` to create a new message.
 */
export const GetTriggerHistoryRequestSchema: GenMessage<GetTriggerHistoryRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 53);

/**
 * @generated from message lvdr.v2.workflow.TriggerHistoryResponse
 */
export type TriggerHistoryResponse = Message<"lvdr.v2.workflow.TriggerHistoryResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.TriggerHistoryRecord records = 1;
   */
  records: TriggerHistoryRecord[];
};

/**
 * Describes the message lvdr.v2.workflow.TriggerHistoryResponse.
 * Use `create(TriggerHistoryResponseSchema)` to create a new message.
 */
export const TriggerHistoryResponseSchema: GenMessage<TriggerHistoryResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 54);

/**
 * WorkflowTemplate describes a built-in or user-authored template. spec is
 * OPAQUE (bytes) — same reasoning as CreateWorkflowRequest.
 *
 * @generated from message lvdr.v2.workflow.WorkflowTemplate
 */
export type WorkflowTemplate = Message<"lvdr.v2.workflow.WorkflowTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * opaque JSON workflow spec
   *
   * @generated from field: bytes spec = 5;
   */
  spec: Uint8Array;

  /**
   * true for system, false for user
   *
   * @generated from field: bool builtin = 6;
   */
  builtin: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.WorkflowTemplate.
 * Use `create(WorkflowTemplateSchema)` to create a new message.
 */
export const WorkflowTemplateSchema: GenMessage<WorkflowTemplate> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 55);

/**
 * --- ListWorkflowTemplates ---
 *
 * @generated from message lvdr.v2.workflow.ListWorkflowTemplatesRequest
 */
export type ListWorkflowTemplatesRequest = Message<"lvdr.v2.workflow.ListWorkflowTemplatesRequest"> & {
};

/**
 * Describes the message lvdr.v2.workflow.ListWorkflowTemplatesRequest.
 * Use `create(ListWorkflowTemplatesRequestSchema)` to create a new message.
 */
export const ListWorkflowTemplatesRequestSchema: GenMessage<ListWorkflowTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 56);

/**
 * @generated from message lvdr.v2.workflow.ListWorkflowTemplatesResponse
 */
export type ListWorkflowTemplatesResponse = Message<"lvdr.v2.workflow.ListWorkflowTemplatesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.WorkflowTemplate templates = 1;
   */
  templates: WorkflowTemplate[];
};

/**
 * Describes the message lvdr.v2.workflow.ListWorkflowTemplatesResponse.
 * Use `create(ListWorkflowTemplatesResponseSchema)` to create a new message.
 */
export const ListWorkflowTemplatesResponseSchema: GenMessage<ListWorkflowTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 57);

/**
 * --- InstantiateWorkflowTemplate ---
 * Params are passed as map<string,string> — the template engine coerces
 * values per the template's declared parameter types. Same shape as the
 * HTTP `{params: {k: v}}` body.
 *
 * @generated from message lvdr.v2.workflow.InstantiateWorkflowTemplateRequest
 */
export type InstantiateWorkflowTemplateRequest = Message<"lvdr.v2.workflow.InstantiateWorkflowTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: map<string, string> params = 2;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.workflow.InstantiateWorkflowTemplateRequest.
 * Use `create(InstantiateWorkflowTemplateRequestSchema)` to create a new message.
 */
export const InstantiateWorkflowTemplateRequestSchema: GenMessage<InstantiateWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 58);

/**
 * @generated from message lvdr.v2.workflow.InstantiateWorkflowTemplateResponse
 */
export type InstantiateWorkflowTemplateResponse = Message<"lvdr.v2.workflow.InstantiateWorkflowTemplateResponse"> & {
  /**
   * empty if CreateWorkflow dep is nil
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * the instantiated spec (opaque JSON)
   *
   * @generated from field: bytes spec = 2;
   */
  spec: Uint8Array;

  /**
   * One-time reveal for webhook tokens minted by the template's CreateWorkflow
   * (see CreateWorkflowResponse.revealed_triggers).
   *
   * @generated from field: repeated lvdr.v2.workflow.TriggerSummary revealed_triggers = 3;
   */
  revealedTriggers: TriggerSummary[];
};

/**
 * Describes the message lvdr.v2.workflow.InstantiateWorkflowTemplateResponse.
 * Use `create(InstantiateWorkflowTemplateResponseSchema)` to create a new message.
 */
export const InstantiateWorkflowTemplateResponseSchema: GenMessage<InstantiateWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 59);

/**
 * --- DeleteWorkflowTemplate ---
 *
 * @generated from message lvdr.v2.workflow.DeleteWorkflowTemplateRequest
 */
export type DeleteWorkflowTemplateRequest = Message<"lvdr.v2.workflow.DeleteWorkflowTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteWorkflowTemplateRequest.
 * Use `create(DeleteWorkflowTemplateRequestSchema)` to create a new message.
 */
export const DeleteWorkflowTemplateRequestSchema: GenMessage<DeleteWorkflowTemplateRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 60);

/**
 * @generated from message lvdr.v2.workflow.DeleteWorkflowTemplateResponse
 */
export type DeleteWorkflowTemplateResponse = Message<"lvdr.v2.workflow.DeleteWorkflowTemplateResponse"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message lvdr.v2.workflow.DeleteWorkflowTemplateResponse.
 * Use `create(DeleteWorkflowTemplateResponseSchema)` to create a new message.
 */
export const DeleteWorkflowTemplateResponseSchema: GenMessage<DeleteWorkflowTemplateResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 61);

/**
 * --- SaveWorkflowAsTemplate ---
 *
 * @generated from message lvdr.v2.workflow.SaveWorkflowAsTemplateRequest
 */
export type SaveWorkflowAsTemplateRequest = Message<"lvdr.v2.workflow.SaveWorkflowAsTemplateRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * optional override
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * opaque — TemplateParam[] JSON
   *
   * @generated from field: bytes parameters = 3;
   */
  parameters: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workflow.SaveWorkflowAsTemplateRequest.
 * Use `create(SaveWorkflowAsTemplateRequestSchema)` to create a new message.
 */
export const SaveWorkflowAsTemplateRequestSchema: GenMessage<SaveWorkflowAsTemplateRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 62);

/**
 * @generated from message lvdr.v2.workflow.SaveWorkflowAsTemplateResponse
 */
export type SaveWorkflowAsTemplateResponse = Message<"lvdr.v2.workflow.SaveWorkflowAsTemplateResponse"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message lvdr.v2.workflow.SaveWorkflowAsTemplateResponse.
 * Use `create(SaveWorkflowAsTemplateResponseSchema)` to create a new message.
 */
export const SaveWorkflowAsTemplateResponseSchema: GenMessage<SaveWorkflowAsTemplateResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 63);

/**
 * --- ValidateWorkflow ---
 *
 * @generated from message lvdr.v2.workflow.ValidateWorkflowRequest
 */
export type ValidateWorkflowRequest = Message<"lvdr.v2.workflow.ValidateWorkflowRequest"> & {
  /**
   * opaque JSON — same parse path as HTTP
   *
   * @generated from field: bytes workflow_spec = 1;
   */
  workflowSpec: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workflow.ValidateWorkflowRequest.
 * Use `create(ValidateWorkflowRequestSchema)` to create a new message.
 */
export const ValidateWorkflowRequestSchema: GenMessage<ValidateWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 64);

/**
 * @generated from message lvdr.v2.workflow.ValidateWorkflowResponse
 */
export type ValidateWorkflowResponse = Message<"lvdr.v2.workflow.ValidateWorkflowResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: repeated string errors = 2;
   */
  errors: string[];

  /**
   * @generated from field: repeated string warnings = 3;
   */
  warnings: string[];

  /**
   * issues are the structured form of errors+warnings (WF-38): path, code,
   * params, message, severity.
   *
   * @generated from field: repeated lvdr.v2.errors.ValidationIssue issues = 4;
   */
  issues: ValidationIssue[];
};

/**
 * Describes the message lvdr.v2.workflow.ValidateWorkflowResponse.
 * Use `create(ValidateWorkflowResponseSchema)` to create a new message.
 */
export const ValidateWorkflowResponseSchema: GenMessage<ValidateWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 65);

/**
 * FieldOptionPb is one choice for a select/surface field.
 *
 * @generated from message lvdr.v2.workflow.FieldOptionPb
 */
export type FieldOptionPb = Message<"lvdr.v2.workflow.FieldOptionPb"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.workflow.FieldOptionPb.
 * Use `create(FieldOptionPbSchema)` to create a new message.
 */
export const FieldOptionPbSchema: GenMessage<FieldOptionPb> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 66);

/**
 * TriggerFieldPb describes one configurable property of a trigger type — the
 * schema the FE renders and the backend validates against. Mirrors
 * triggers.TriggerField.
 *
 * @generated from message lvdr.v2.workflow.TriggerFieldPb
 */
export type TriggerFieldPb = Message<"lvdr.v2.workflow.TriggerFieldPb"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string help = 3;
   */
  help: string;

  /**
   * text|select|cron|regex|checkbox|string_list|surface|label
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: bool required = 5;
   */
  required: boolean;

  /**
   * @generated from field: repeated lvdr.v2.workflow.FieldOptionPb options = 6;
   */
  options: FieldOptionPb[];
};

/**
 * Describes the message lvdr.v2.workflow.TriggerFieldPb.
 * Use `create(TriggerFieldPbSchema)` to create a new message.
 */
export const TriggerFieldPbSchema: GenMessage<TriggerFieldPb> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 67);

/**
 * TriggerDescriptorPb is the complete definition of one trigger type as seen by
 * the FE. Mirrors triggers.TriggerDescriptor (sans the Go Build func).
 *
 * @generated from message lvdr.v2.workflow.TriggerDescriptorPb
 */
export type TriggerDescriptorPb = Message<"lvdr.v2.workflow.TriggerDescriptorPb"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * lucide icon hint
   *
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * "automatic" | "manual"
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * gating flag id; "" = always available
   *
   * @generated from field: string feature = 5;
   */
  feature: string;

  /**
   * @generated from field: repeated lvdr.v2.workflow.TriggerFieldPb fields = 6;
   */
  fields: TriggerFieldPb[];

  /**
   * @generated from field: repeated string payload_keys = 7;
   */
  payloadKeys: string[];

  /**
   * help is the descriptor-level sentence naming the run budget and, for
   * cron, the schedule floor (WF-38).
   *
   * @generated from field: string help = 8;
   */
  help: string;
};

/**
 * Describes the message lvdr.v2.workflow.TriggerDescriptorPb.
 * Use `create(TriggerDescriptorPbSchema)` to create a new message.
 */
export const TriggerDescriptorPbSchema: GenMessage<TriggerDescriptorPb> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 68);

/**
 * ContextSurfacePb is a domain object on which a manual trigger renders a
 * button. Mirrors triggers.ContextSurface.
 *
 * @generated from message lvdr.v2.workflow.ContextSurfacePb
 */
export type ContextSurfacePb = Message<"lvdr.v2.workflow.ContextSurfacePb"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: repeated string payload_keys = 3;
   */
  payloadKeys: string[];
};

/**
 * Describes the message lvdr.v2.workflow.ContextSurfacePb.
 * Use `create(ContextSurfacePbSchema)` to create a new message.
 */
export const ContextSurfacePbSchema: GenMessage<ContextSurfacePb> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 69);

/**
 * --- TriggerCatalog ---
 *
 * @generated from message lvdr.v2.workflow.TriggerCatalogRequest
 */
export type TriggerCatalogRequest = Message<"lvdr.v2.workflow.TriggerCatalogRequest"> & {
};

/**
 * Describes the message lvdr.v2.workflow.TriggerCatalogRequest.
 * Use `create(TriggerCatalogRequestSchema)` to create a new message.
 */
export const TriggerCatalogRequestSchema: GenMessage<TriggerCatalogRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 70);

/**
 * @generated from message lvdr.v2.workflow.TriggerCatalogResponse
 */
export type TriggerCatalogResponse = Message<"lvdr.v2.workflow.TriggerCatalogResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.TriggerDescriptorPb triggers = 1;
   */
  triggers: TriggerDescriptorPb[];

  /**
   * @generated from field: repeated lvdr.v2.workflow.ContextSurfacePb surfaces = 2;
   */
  surfaces: ContextSurfacePb[];
};

/**
 * Describes the message lvdr.v2.workflow.TriggerCatalogResponse.
 * Use `create(TriggerCatalogResponseSchema)` to create a new message.
 */
export const TriggerCatalogResponseSchema: GenMessage<TriggerCatalogResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 71);

/**
 * --- ManualActions (bindings on a surface for the caller) ---
 *
 * @generated from message lvdr.v2.workflow.ManualActionPb
 */
export type ManualActionPb = Message<"lvdr.v2.workflow.ManualActionPb"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string trigger_id = 2;
   */
  triggerId: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.workflow.ManualActionPb.
 * Use `create(ManualActionPbSchema)` to create a new message.
 */
export const ManualActionPbSchema: GenMessage<ManualActionPb> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 72);

/**
 * @generated from message lvdr.v2.workflow.ManualActionsRequest
 */
export type ManualActionsRequest = Message<"lvdr.v2.workflow.ManualActionsRequest"> & {
  /**
   * ContextSurface id
   *
   * @generated from field: string surface = 1;
   */
  surface: string;
};

/**
 * Describes the message lvdr.v2.workflow.ManualActionsRequest.
 * Use `create(ManualActionsRequestSchema)` to create a new message.
 */
export const ManualActionsRequestSchema: GenMessage<ManualActionsRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 73);

/**
 * @generated from message lvdr.v2.workflow.ManualActionsResponse
 */
export type ManualActionsResponse = Message<"lvdr.v2.workflow.ManualActionsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.ManualActionPb actions = 1;
   */
  actions: ManualActionPb[];
};

/**
 * Describes the message lvdr.v2.workflow.ManualActionsResponse.
 * Use `create(ManualActionsResponseSchema)` to create a new message.
 */
export const ManualActionsResponseSchema: GenMessage<ManualActionsResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 74);

/**
 * --- FireManualTrigger ---
 * object_id is the surface object the button was rendered on; the backend
 * resolves the payload server-side under the session DEK (never client content)
 * and enforces owner checks on BOTH the trigger and the object (IDOR closure).
 *
 * @generated from message lvdr.v2.workflow.FireManualTriggerRequest
 */
export type FireManualTriggerRequest = Message<"lvdr.v2.workflow.FireManualTriggerRequest"> & {
  /**
   * @generated from field: string trigger_id = 1;
   */
  triggerId: string;

  /**
   * @generated from field: string object_id = 2;
   */
  objectId: string;
};

/**
 * Describes the message lvdr.v2.workflow.FireManualTriggerRequest.
 * Use `create(FireManualTriggerRequestSchema)` to create a new message.
 */
export const FireManualTriggerRequestSchema: GenMessage<FireManualTriggerRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 75);

/**
 * @generated from message lvdr.v2.workflow.FireManualTriggerResponse
 */
export type FireManualTriggerResponse = Message<"lvdr.v2.workflow.FireManualTriggerResponse"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: bool started = 2;
   */
  started: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.FireManualTriggerResponse.
 * Use `create(FireManualTriggerResponseSchema)` to create a new message.
 */
export const FireManualTriggerResponseSchema: GenMessage<FireManualTriggerResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 76);

/**
 * RunDesignerTurnRequest sends one user message to the workflow_designer agent
 * for a given workflow. workflow_id may be empty to start a brand-new workflow
 * (the agent creates it on the first `propose`).
 *
 * @generated from message lvdr.v2.workflow.RunDesignerTurnRequest
 */
export type RunDesignerTurnRequest = Message<"lvdr.v2.workflow.RunDesignerTurnRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message lvdr.v2.workflow.RunDesignerTurnRequest.
 * Use `create(RunDesignerTurnRequestSchema)` to create a new message.
 */
export const RunDesignerTurnRequestSchema: GenMessage<RunDesignerTurnRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 77);

/**
 * RunDesignerTurnResponse is the terminal ack for a turn. The substance of the
 * turn streams as DesignerTurnStreamEvent chunks; this final message carries the
 * resolved workflow_id (important for the new-workflow case) and whether a draft
 * was staged for review.
 *
 * @generated from message lvdr.v2.workflow.RunDesignerTurnResponse
 */
export type RunDesignerTurnResponse = Message<"lvdr.v2.workflow.RunDesignerTurnResponse"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: bool draft_staged = 2;
   */
  draftStaged: boolean;

  /**
   * DEK evicted — retry after unlock
   *
   * @generated from field: bool session_locked = 3;
   */
  sessionLocked: boolean;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.workflow.RunDesignerTurnResponse.
 * Use `create(RunDesignerTurnResponseSchema)` to create a new message.
 */
export const RunDesignerTurnResponseSchema: GenMessage<RunDesignerTurnResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 78);

/**
 * DesignerToolStep is one tool the agent invoked during a turn (for transparency
 * in the panel — "added step summarize", "rewired b→c").
 *
 * @generated from message lvdr.v2.workflow.DesignerToolStep
 */
export type DesignerToolStep = Message<"lvdr.v2.workflow.DesignerToolStep"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string summary = 2;
   */
  summary: string;
};

/**
 * Describes the message lvdr.v2.workflow.DesignerToolStep.
 * Use `create(DesignerToolStepSchema)` to create a new message.
 */
export const DesignerToolStepSchema: GenMessage<DesignerToolStep> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 79);

/**
 * DesignerTurnStreamEvent is one streamed chunk of a designer turn. Mirrors the
 * chat streaming pattern: deltas of assistant text, then tool steps, then a
 * final staged_diff + done. staged_diff is the JSON the panel feeds to the
 * canvas overlay (added/changed/removed step ids).
 *
 * @generated from message lvdr.v2.workflow.DesignerTurnStreamEvent
 */
export type DesignerTurnStreamEvent = Message<"lvdr.v2.workflow.DesignerTurnStreamEvent"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string delta_text = 2;
   */
  deltaText: string;

  /**
   * @generated from field: lvdr.v2.workflow.DesignerToolStep tool_step = 3;
   */
  toolStep?: DesignerToolStep | undefined;

  /**
   * JSON: {added:[],changed:[],removed:[]}
   *
   * @generated from field: string staged_diff = 4;
   */
  stagedDiff: string;

  /**
   * @generated from field: bool done = 5;
   */
  done: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.DesignerTurnStreamEvent.
 * Use `create(DesignerTurnStreamEventSchema)` to create a new message.
 */
export const DesignerTurnStreamEventSchema: GenMessage<DesignerTurnStreamEvent> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 80);

/**
 * CapabilityDriftAlert is pushed when the background reconcile scan finds
 * workflows whose assumed capabilities are no longer available. The client deep-
 * links into the first affected workflow's designer panel, where a repair draft
 * is already staged. Proactive ≠ autonomous: nothing is published.
 *
 * @generated from message lvdr.v2.workflow.CapabilityDriftAlert
 */
export type CapabilityDriftAlert = Message<"lvdr.v2.workflow.CapabilityDriftAlert"> & {
  /**
   * @generated from field: string capability_id = 1;
   */
  capabilityId: string;

  /**
   * @generated from field: repeated string affected_workflows = 2;
   */
  affectedWorkflows: string[];

  /**
   * @generated from field: string summary = 3;
   */
  summary: string;
};

/**
 * Describes the message lvdr.v2.workflow.CapabilityDriftAlert.
 * Use `create(CapabilityDriftAlertSchema)` to create a new message.
 */
export const CapabilityDriftAlertSchema: GenMessage<CapabilityDriftAlert> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 81);

/**
 * WorkflowResultEvent is pushed UNSOLICITED when a workflow run ends COMPLETED or
 * FAILED, on any run path (manual, trigger, delay resume, approve, plan-decline). It is
 * fanned out per owner by workflow.RealtimeHub (internal/workflow/realtime.go), so it
 * reaches whichever backend holds the owner's socket. Cancellation is not pushed: the
 * cancelling client already holds CancelWorkflowInstanceResponse.
 *
 * workflow_id, instance_id and finished_at have NO reader yet: the one consumer
 * (web workflowNotifications.ts) renders a toast from workflow_name, status and
 * error. They identify the run so that a client can later de-duplicate or link
 * to it without a wire change. Do not read their presence as a feature.
 *
 * @generated from message lvdr.v2.workflow.WorkflowResultEvent
 */
export type WorkflowResultEvent = Message<"lvdr.v2.workflow.WorkflowResultEvent"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string workflow_name = 2;
   */
  workflowName: string;

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId: string;

  /**
   * "completed" | "failed"
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * first failed step's error, <= 300 runes; empty when unknown
   *
   * @generated from field: string error = 5;
   */
  error: string;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 6;
   */
  finishedAt?: Timestamp | undefined;

  /**
   * as WorkflowInstanceSummary.end_reason
   *
   * @generated from field: string end_reason = 7;
   */
  endReason: string;
};

/**
 * Describes the message lvdr.v2.workflow.WorkflowResultEvent.
 * Use `create(WorkflowResultEventSchema)` to create a new message.
 */
export const WorkflowResultEventSchema: GenMessage<WorkflowResultEvent> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 82);

/**
 * @generated from message lvdr.v2.workflow.ListSendGrantsRequest
 */
export type ListSendGrantsRequest = Message<"lvdr.v2.workflow.ListSendGrantsRequest"> & {
};

/**
 * Describes the message lvdr.v2.workflow.ListSendGrantsRequest.
 * Use `create(ListSendGrantsRequestSchema)` to create a new message.
 */
export const ListSendGrantsRequestSchema: GenMessage<ListSendGrantsRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 83);

/**
 * RevokeSendGrantRequest revokes one grant. An empty grant_id revokes ALL of
 * the user's grants — the kill switch, mirroring RevokeBackgroundRequest.
 *
 * @generated from message lvdr.v2.workflow.RevokeSendGrantRequest
 */
export type RevokeSendGrantRequest = Message<"lvdr.v2.workflow.RevokeSendGrantRequest"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;
};

/**
 * Describes the message lvdr.v2.workflow.RevokeSendGrantRequest.
 * Use `create(RevokeSendGrantRequestSchema)` to create a new message.
 */
export const RevokeSendGrantRequestSchema: GenMessage<RevokeSendGrantRequest> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 84);

/**
 * @generated from message lvdr.v2.workflow.SendGrantItem
 */
export type SendGrantItem = Message<"lvdr.v2.workflow.SendGrantItem"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * best-effort; empty when the workflow is gone
   *
   * @generated from field: string workflow_name = 3;
   */
  workflowName: string;

  /**
   * @generated from field: string step_id = 4;
   */
  stepId: string;

  /**
   * "google_calendar.apply_blocks"
   *
   * @generated from field: string action = 5;
   */
  action: string;

  /**
   * RFC3339
   *
   * @generated from field: string granted_at = 6;
   */
  grantedAt: string;

  /**
   * RFC3339
   *
   * @generated from field: string expires_at = 7;
   */
  expiresAt: string;

  /**
   * server-evaluated, so the client never guesses
   *
   * @generated from field: bool expired = 8;
   */
  expired: boolean;

  /**
   * orphaned marks a grant whose workflow no longer exists. Such grants are
   * still listed so a lingering authorisation is always revocable.
   *
   * @generated from field: bool orphaned = 9;
   */
  orphaned: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.SendGrantItem.
 * Use `create(SendGrantItemSchema)` to create a new message.
 */
export const SendGrantItemSchema: GenMessage<SendGrantItem> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 85);

/**
 * StepReleaseItem is a step standing at "always allow" — the other thing a user
 * needs to be able to see and take back.
 *
 * @generated from message lvdr.v2.workflow.StepReleaseItem
 */
export type StepReleaseItem = Message<"lvdr.v2.workflow.StepReleaseItem"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string workflow_name = 2;
   */
  workflowName: string;

  /**
   * @generated from field: string step_id = 3;
   */
  stepId: string;

  /**
   * @generated from field: string step_type = 4;
   */
  stepType: string;
};

/**
 * Describes the message lvdr.v2.workflow.StepReleaseItem.
 * Use `create(StepReleaseItemSchema)` to create a new message.
 */
export const StepReleaseItemSchema: GenMessage<StepReleaseItem> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 86);

/**
 * SendGrantsResponse is the shared response for list/revoke — the server always
 * echoes full current state so the client never has to guess, mirroring
 * BackgroundAuthResponse.
 *
 * @generated from message lvdr.v2.workflow.SendGrantsResponse
 */
export type SendGrantsResponse = Message<"lvdr.v2.workflow.SendGrantsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.workflow.SendGrantItem grants = 1;
   */
  grants: SendGrantItem[];

  /**
   * @generated from field: repeated lvdr.v2.workflow.StepReleaseItem step_releases = 2;
   */
  stepReleases: StepReleaseItem[];

  /**
   * account_allows_send is key 2. A step release does nothing while this is
   * off, so the UI must be able to say so rather than showing a release that
   * silently has no effect.
   *
   * @generated from field: bool account_allows_send = 3;
   */
  accountAllowsSend: boolean;
};

/**
 * Describes the message lvdr.v2.workflow.SendGrantsResponse.
 * Use `create(SendGrantsResponseSchema)` to create a new message.
 */
export const SendGrantsResponseSchema: GenMessage<SendGrantsResponse> = /*@__PURE__*/
  messageDesc(file_workflow_workflow, 87);

/**
 * SendRelease is how far the human's approval reaches. It is deliberately an
 * enum and not a bool: "approve" is three different decisions with three
 * different blast radii, and collapsing them would hide that from the person
 * making the call. COS-05 §6.5.
 *
 * @generated from enum lvdr.v2.workflow.SendRelease
 */
export enum SendRelease {
  /**
   * ONCE approves the pinned payload in front of the user and nothing else.
   * Zero value, so every pre-existing caller keeps today's behaviour verbatim.
   *
   * @generated from enum value: SEND_RELEASE_ONCE = 0;
   */
  ONCE = 0,

  /**
   * NEXT_RUN additionally writes a single-use, expiring grant bounded by an
   * envelope that is re-checked against the actual payload at send time. It
   * does NOT approve a future payload — that is what the pinning rule forbids.
   *
   * @generated from enum value: SEND_RELEASE_NEXT_RUN = 1;
   */
  NEXT_RUN = 1,

  /**
   * ALWAYS sets the standing per-step key. Broadest of the three and the only
   * one not envelope-checked: it releases whatever that step later produces,
   * until the step's config changes.
   *
   * @generated from enum value: SEND_RELEASE_ALWAYS = 2;
   */
  ALWAYS = 2,
}

/**
 * Describes the enum lvdr.v2.workflow.SendRelease.
 */
export const SendReleaseSchema: GenEnum<SendRelease> = /*@__PURE__*/
  enumDesc(file_workflow_workflow, 0);

